import React from 'react';

const StepTripCancellationAndTripInterruptionSharedTravelDelay = () => (
  <ol>
    <li>
      Copies of cancelled checks or credit card statements that shows all payments made for the trip with an invoice from your
      Travel Provider showing the total cost paid for the trip
    </li>
    <li>
      Copies of reimbursement statements issued by an airline carrier, airport facility, car rental agency, travel agent, hotel/motel
      or other similar establishment or any other insurance company providing reimbursement to you for the loss.
    </li>
    <li>
      Statement from Hotel/Motel, Airline Carrier or Airport Facility that concerns your Delay.
      Note: Any cancellation or delay of flight must be documented by the airline.
    </li>
    <li>
      Car Rental Agreement (if applicable)
    </li>
    <li>
      Airline Ticket Stub/Receipt (if applicable)
    </li>
    <li>
      Police Report (if applicable)
    </li>
    <li>
      Copies of reimbursement statements issued by an airline carrier, airport facility, car rental agency, travel agent, hotel/motel
      or other similar establishment or any other insurance company providing reimbursement to you for the loss.
    </li>
  </ol>
);

export default StepTripCancellationAndTripInterruptionSharedTravelDelay;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepTripCancellationAndTripInterruption/components/StepTripCancellationAndTripInterruptionSharedTravelDelay.js